import { request } from './request';

export const getAllPolysomnographies = (
  page = 1,
  filterString = '',
  limit = 50,
) => request(`polysomnographies?page=${page}${filterString}&limit=${limit}`);

export const updatePolysomnography = (id, body) =>
  request(`polysomnographies/${id}`, { method: 'PATCH', body });

export const getPolysomnographyById = (id) =>
  request(`polysomnographies/${id}`);

export const deletePolysomnography = (id, body) =>
  request(
    `polysomnographies/${id}`,
    { method: 'DELETE', body },
    'Polysomnography deleted successfully!',
  );

export const createPolysomnography = (body) =>
  request(`polysomnographies`, { method: 'POST', body });
